import { render, staticRenderFns } from "./template.html?vue&type=template&id=5d849c66&scoped=true&"
import script from "./SidenaviNewentries.vue?vue&type=script&lang=ts&"
export * from "./SidenaviNewentries.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=5d849c66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d849c66",
  null
  
)

export default component.exports